import { ActionType, createReducer } from 'typesafe-actions';
import {
  addBettingTimeToastAction,
  addToastAction,
  removeBettingTimeToastAction,
  removeToastAction,
} from './actions';
import { IToastState } from './types';

export const toastState: IToastState = {
  toastItem: null,
  bettingTimeToast: null,
};

const actions = {
  addToastAction,
  removeToastAction,
  addBettingTimeToastAction,
  removeBettingTimeToastAction,
};

export const toastReducer = createReducer<IToastState, ActionType<typeof actions>>(toastState)
  .handleAction(addToastAction, (state, { payload }) => ({
    ...state,
    toastItem: payload,
  }))
  .handleAction(removeToastAction, (state) => ({
    ...state,
    toastItem: null,
  }))
  .handleAction(addBettingTimeToastAction, (state, { payload }) => ({
    ...state,
    bettingTimeToast: payload,
  }))
  .handleAction(removeBettingTimeToastAction, (state) => ({
    ...state,
    bettingTimeToast: null,
  }));
